import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { cx } from "./cx.js";
export function Segmented({ value, options, onChange, label, grid = false, className, }) {
    const box = useRef(null);
    function move(step) {
        const at = options.findIndex((option) => option.key === value);
        const next = options[(at + step + options.length) % options.length];
        if (next === undefined)
            return;
        onChange(next.key);
        box.current?.querySelector(`[data-key="${next.key}"]`)?.focus();
    }
    return (_jsx("div", { ref: box, role: "radiogroup", "aria-label": label, className: cx("seg", grid && "seg-2x2", className), onKeyDown: (event) => {
            if (event.key === "ArrowRight" || event.key === "ArrowDown") {
                event.preventDefault();
                move(1);
            }
            if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
                event.preventDefault();
                move(-1);
            }
        }, children: options.map((option) => {
            const on = option.key === value;
            return (_jsxs("button", { type: "button", role: "radio", "aria-checked": on, "data-key": option.key, tabIndex: on ? 0 : -1, className: "seg-cell", onClick: () => onChange(option.key), children: [option.label, option.count !== undefined && option.count > 0 && _jsx("span", { className: "seg-cnt caption-1", children: option.count })] }, option.key));
        }) }));
}
//# sourceMappingURL=Segmented.js.map